import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useApiTokensStore } from '@pages/admin-tools'
import { getFirstQueryValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useApiTokensStore()

  const userId = Number(getFirstQueryValue(to.query?.user_id))
  store.setFilterUserId(userId > 0 ? userId : null)

  store.setFilterSearch(getFirstQueryValue(to.query?.search) || null)
})
